<template>
    <div>
        <div v-if="this.$store.state.loading_state" class="loading">
            <div class='loading_main'>
                <img src="@/assets/image/icon_loading.gif">
                <div class="loading_text">{{this.$store.state.loading_text}}</div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "App",
        created() {
            let query = this.$methods.get_query();
            if (query.token) {
                localStorage.setItem("token", query.token);
            }


        },
    };
</script>

<style lang="less">
    @import '@/assets/css/app.less';

    .loading {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
        z-index: 9999999999;
        display: flex;
        justify-content: center;
        align-content: center;
    }

    .loading_main {
        position: absolute;
        top: 50%;
        text-align: center;
        margin-top: -22.5px;
    }

    .loading .loading_main img {
        width: 110px;
    }

    .loading .loading_main .loading_text {
        color: #ffffff;
        font-size: 13px;
        margin-top: 5px;
    }
</style>